import { getDisplayMode, accordion } from '../common/libs.js';
const setOpencampusNav = () => {
  const setOpencampusNavToggle = () => {
    if (getDisplayMode() == 1) {
      console.log('pc')
    } else {
      accordion();
    }
  }

  setOpencampusNavToggle();
}

export default setOpencampusNav;